<template>
  <div class="planning-shift">
    <QItem v-ripple clickable :class="statusClass" @click="onShiftClick">
      <QItemSection avatar>
        <Avatar size="55px" :picture="shift.getExtraBooked().getPicture()" />
      </QItemSection>

      <QItemSection>
        <QItemLabel>
          <h5>{{ shift.getExtraBooked().getIdentity().firstname }} - {{ shift.getQualification().getLabel() }}</h5>
        </QItemLabel>
        <QItemLabel>
          <div class="planning-shift-schedule">
            <span>{{ shift.getStartTimeDisplay() }}</span>
            <QIcon name="icon-f-arrow-right" class="planning-shift-schedule-time" />
            <span>{{ shift.getEndTimeDisplay() }}</span>
            <template v-if="shift.getBreakDisplay()">
              <QIcon name="icon-f-pause" class="planning-shift-schedule-break" />
              <span>{{ shift.getBreakDisplay() }}</span>
            </template>
          </div>
        </QItemLabel>
      </QItemSection>
      <QItemSection side top>
        <QBtn dense flat icon="icon-f-phone" @click.stop="openPhone">
          <QTooltip v-if="isWeb" anchor="center left" self="center middle" content-class="bg-black">
            {{ formattedPhone }}
          </QTooltip>
        </QBtn>
      </QItemSection>
    </QItem>
    <div v-if="shift.isCanceledByExtra()" class="planning-shift-canceled-info">
      {{ $t("ETAB.PAGES.PLANNING.@EXTRA_CANCELED") }}
    </div>
  </div>
</template>

<script>
  import { PlanningShiftModel } from "@core/models";
  import { JavascriptHelpers } from "@core/helpers";
  import { EventManager } from "@core/managers/event.manager";
  import { ETAB_EVENTS } from "@etab/config";

  export default {
    props: {
      shift: {
        type: Object,
        default: () => new PlanningShiftModel(),
      },
    },
    computed: {
      statusClass() {
        if (this.shift.isCanceledByExtra()) {
          return "planning-shift-canceled";
        }
        return "planning-shift-booked";
      },
      formattedPhone() {
        return JavascriptHelpers.formatPhoneNumber(this.shift.getExtraBooked().getIdentity().phone);
      },
    },
    methods: {
      onShiftClick() {
        EventManager.emit(ETAB_EVENTS.SHIFT_PLANNING.OPEN_SHIFT, this.shift);
      },
      openPhone() {
        EventManager.emit(ETAB_EVENTS.SHIFT_PLANNING.OPEN_PHONE, this.shift);
      },
    },
  };
</script>

<style lang="scss">
  .planning-shift {
    margin: 5px 0;
    background-color: white;
    border-radius: 4px;
    overflow: hidden;

    .q-item {
      & {
        padding-left: 10px;
        padding-right: 10px;
      }
      &.planning-shift-canceled {
        border-left: 5px solid $negative;
      }

      &.planning-shift-booked {
        border-left: 5px solid $positive;
      }

      h5 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: $common-font-family;
        font-weight: bold;
        color: $primary-medium;
      }

      .planning-shift-schedule {
        display: flex;
        align-items: center;
        color: $primary-medium;

        > i {
          color: $primary-light;
        }

        .planning-shift-schedule-time {
          margin: 0 10px;
        }
        .planning-shift-schedule-break {
          margin-left: 20px;
          margin-right: 5px;
        }
      }
    }

    .planning-shift-canceled-info {
      font-size: 0.9em;
      background-color: $negative;
      color: white;
      text-align: center;
      padding: 5px;
    }
  }
</style>
